import { render, staticRenderFns } from "./ProfilesAssociation.vue?vue&type=template&id=1e10ae48&"
import script from "./ProfilesAssociation.vue?vue&type=script&lang=ts&"
export * from "./ProfilesAssociation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports